export default {
  API_ENDPOINT: "http://localhost:8000/packrat",
  TOKEN_KEY: "packrat-client-auth-token",
  API_KEY: process.env.REACT_APP_API_KEY,
};
